import { useEffect, useState } from 'react';
import { onToast } from '../../lib/toast.js';

interface Active {
  id: number;
  title: string;
  body?: string;
  kind: 'success' | 'info' | 'warn' | 'danger';
}

export function ToastContainer() {
  const [active, setActive] = useState<Active | null>(null);

  useEffect(() => {
    const off = onToast((t) => {
      setActive({ id: t.id, title: t.title, body: t.body, kind: t.kind });
      const timer = window.setTimeout(() => {
        setActive((a) => (a && a.id === t.id ? null : a));
      }, 3000);
      return () => window.clearTimeout(timer);
    });
    return () => {
      off();
    };
  }, []);

  if (!active) return null;

  return (
    <div id="toast" className={`show toast-${active.kind}`}>
      <div className="tt">{active.title}</div>
      {active.body ? <div>{active.body}</div> : null}
    </div>
  );
}
